<div class="milestones-progress-overlay" *ngIf="currentExperience > -1">
  <div class="milestones-progress-overlay__item" [ngClass]="{'blocked': item.points > currentExperience}" *ngFor="let item of milestones">
    <div class="milestones-progress-overlay__item-icon">
      <img [src]="'/assets/game-dashboard-icons/milestones/' + item.iconName" [alt]="item.name">

      <div class="milestones-progress-overlay__item-icon-block-icon"><brt-icon [icon]="'locked'"></brt-icon></div>
    </div>
    <div class="milestones-progress-overlay__item-name">{{item.name}}</div>
    <div class="milestones-progress-overlay__item-points">{{item.points|number:'.'}} Punkte</div>
  </div>
</div>
